import { DNDBannerWrapper } from 'Components/BannerWrapper/DNDBannerWrapper';
import { observer } from 'mobx-react';
import React, { useMemo } from 'react';
import { ConnectionBannerWrapper } from './ConnectionBannerWrapper';
import { DesktopNotificationsBannerWrapper } from './DesktopNotificationsBannerWrapper';
import useBannerLayoutVariant from './hooks/useBannerLayoutVariant';
import useShowConnectionBanner from './hooks/useShowConnectionBanner';
import useShowDesktopNotificationsBanner from './hooks/useShowDesktopNotificationsBanner';
import useShowDndBanner from './hooks/useShowDndBanner';
import useShowUpdateAvailableBanner from './hooks/useShowUpdateAvailableBanner';
import { BannerWrapperProps } from './index.types';
import { UpdateAvailableBannerWrapper } from './UpdateAvailableBannerWrapper';

export const BannerWrapper = observer(
  ({ defaultBanner }: BannerWrapperProps) => {
    const { ref, variant } = useBannerLayoutVariant<HTMLDivElement>();

    const showUpdateAvailableBanner = useShowUpdateAvailableBanner();
    const connectionBanner = useShowConnectionBanner();
    const showDndBanner = useShowDndBanner();
    const {
      action: desktopNotificationBannerAction,
      handleClose: handleDesktopNotificationClose,
    } = useShowDesktopNotificationsBanner() ?? {};

    const banner = useMemo(() => {
      if (showUpdateAvailableBanner) {
        return <UpdateAvailableBannerWrapper variant={variant} />;
      }

      if (connectionBanner) {
        return (
          <ConnectionBannerWrapper type={connectionBanner} variant={variant} />
        );
      }

      if (showDndBanner) {
        return <DNDBannerWrapper variant={variant} />;
      }

      if (desktopNotificationBannerAction) {
        return (
          <DesktopNotificationsBannerWrapper
            action={desktopNotificationBannerAction}
            onClose={handleDesktopNotificationClose}
            variant={variant}
          />
        );
      }

      return <>{defaultBanner}</>;
    }, [
      showUpdateAvailableBanner,
      connectionBanner,
      showDndBanner,
      desktopNotificationBannerAction,
      defaultBanner,
      handleDesktopNotificationClose,
      variant,
    ]);

    return <div ref={ref}>{banner}</div>;
  }
);
